<template>
  <li
    class="blog-card mx-auto max-w-[360px] overflow-hidden rounded-lg bg-white shadow-[0px_0px_35px_rgba(0,0,0,0.08)] not-first:mt-9"
  >
    <div class="h-[200px] w-full animate-pulse bg-gray-200" />
    <div class="space-y-4 px-[22px] py-4">
      <div class="h-4 w-1/2 animate-pulse rounded bg-gray-200" />
      <div class="h-5 w-full animate-pulse rounded bg-gray-200" />
      <div class="flex items-center gap-3 pt-2">
        <div class="h-9 w-9 animate-pulse rounded-full bg-gray-200" />
        <div class="h-3 w-24 animate-pulse rounded bg-gray-200" />
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
</script>

<style scoped>
@media (min-width: 768px) {
  .blog-card {
    @apply mx-0;
  }
}
</style>
